import { SubscriptionHookOptions, useSubscription } from "@apollo/client";

import { JourneyTasksDocument, JourneyTasksSubscription, JourneyTasksSubscriptionVariables } from "@typing/Generated";

type Task = NonNullable<JourneyTasksSubscription["journeyTasks"]>["task"];

type UpdateFunc = (task: Task) => void;

const useSubscribeToJourneyTasks = (
  journeyId: string,
  onUpdate?: UpdateFunc,
  options?: SubscriptionHookOptions<JourneyTasksSubscription, JourneyTasksSubscriptionVariables>
) => {
  useSubscription<JourneyTasksSubscription, JourneyTasksSubscriptionVariables>(JourneyTasksDocument, {
    ...options,
    onData: data => {
      if (data.data.data?.journeyTasks?.task && onUpdate) {
        onUpdate(data.data.data.journeyTasks.task);
      }
    },
    variables: {
      journeyId
    }
  });
};

export default useSubscribeToJourneyTasks;
